// List of public holidays for the current year
// You can update this list as needed
export const publicHolidays = [
  // January
  { date: "2026-01-01", name: "New Year’s Day" },
  { date: "2026-01-14", name: "Makar Sankranti / Pongal 🌞" },
  { date: "2026-01-26", name: "Republic Day" },

  // February
  { date: "2026-02-15", name: "Maha Shivaratri" },

  // March
  { date: "2026-03-04", name: "Holi 🎨" },

  // April
  { date: "2026-04-03", name: "Good Friday ✝️" },

  // August
  { date: "2026-08-15", name: "Independence Day" },

  // September
  { date: "2026-09-04", name: "Janmashtami 🐄" },
  { date: "2026-09-14", name: "Ganesh Chaturthi 🐘" },

  // October
  { date: "2026-10-02", name: "Gandhi Jayanti" },
  { date: "2026-10-20", name: "Dussehra / Vijayadashami 🌼" },

  // November
  { date: "2026-11-08", name: "Diwali ✨" },

  // December
  { date: "2026-12-25", name: "Christmas Day 🎄" }
];
